import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { StationBlockAlertInsertRequest } from "../../shared/station-block-alert-insert-request";
import * as moment from "moment";
import { DataService_BlockListSetup } from "../../shared/data.service";
import { SbaAddHomeroomComponent } from "./sba-add-homeroom/sba-add-homeroom.component";
import { SbaAddGroupComponent } from "./sba-add-group/sba-add-group.component";
import { SbaAddPersonComponent } from "./sba-add-person/sba-add-person.component";

@Component({
	selector: "app-add-station-block-alert",
	templateUrl: "./add-station-block-alert.component.html",
	styleUrls: ["./add-station-block-alert.component.css"],
})
export class AddStationBlockAlertComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private dataService: DataService_BlockListSetup,
		private confirmationService: ConfirmationService,
		private dialogService: DialogService
	) {}
	ngOnInit(): void {
		this.SelectedSchool = this.dialogConfig.data.SelectedSchool;
		this.SchoolName = this.SelectedSchool.SchoolFullName;
	}

	//////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////

	SelectedSchool: any;
	SchoolName: string = "";

	Message: string = "";

	DateRangeID: number = 1;
	lstDateRange: any = [
		{
			ID: 1,
			Desc: "Every Day",
		},
		{
			ID: 2,
			Desc: "Date Range",
		},
		{
			ID: 3,
			Desc: "Block after",
		},
		{
			ID: 4,
			Desc: "Block until",
		},
	];

	StartDate: Date = new Date();
	EndDate: Date = new Date();

	TimeRangeID: number = 1;
	lstTimeRange: any = [
		{
			ID: 1,
			Desc: "Block All Day",
		},
		{
			ID: 2,
			Desc: "Block During Time Range",
		},
		{
			ID: 3,
			Desc: "Block After (Ex. Can't enter after-school program)",
		},
		{
			ID: 4,
			Desc: "Block Before (Ex. Night students can't enter during the day)",
		},
	];

	StartTime: Date = new Date();
	EndTime: Date = new Date();

	PriorityID: number = 1;
	lstPriority: any = [
		{
			ID: 1,
			Desc: "High",
		},
		{
			ID: 2,
			Desc: "Medium",
		},
		{
			ID: 3,
			Desc: "Low",
		},
	];

	lstPerson: any = [];
	lstGroup: any = [];
	lstHomeroom: any = [];

	HomeroomPageFirst: number = 0;
	HomeroomPageRows: number = 5;
	GroupPageFirst: number = 0;
	GroupPageRows: number = 5;
	PersonPageFirst: number = 0;
	PersonPageRows: number = 5;

	Processing: boolean = false;
	errorMessage: string = "";

	//////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////

	onAddHomeroom() {
		var ref = this.dialogService.open(SbaAddHomeroomComponent, {
			header: "Add Homeroom",
			width: "fit-content",
			data: {
				SchoolID: this.SelectedSchool.SchoolID,
				lstSelected: this.lstHomeroom,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response.lstSelected != undefined) {
				this.lstHomeroom = response.lstSelected;
			}
		});
	}

	onRemoveHomeroom(val) {
		this.lstHomeroom = this.lstHomeroom.filter((h) => h.HomeroomID != val.HomeroomID);
	}

	onAddGroup() {
		var ref = this.dialogService.open(SbaAddGroupComponent, {
			header: "Add Group",
			width: "fit-content",
			data: {
				SchoolID: this.SelectedSchool.SchoolID,
				lstSelected: this.lstGroup,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response.lstSelected != undefined) {
				this.lstGroup = response.lstSelected;
			}
		});
	}

	onRemoveGroup(val) {
		this.lstGroup = this.lstGroup.filter((g) => g.GroupID != val.GroupID);
	}

	onAddPerson() {
		var ref = this.dialogService.open(SbaAddPersonComponent, {
			header: "Add Person",
			width: "fit-content",
			data: {
				SchoolID: this.SelectedSchool.SchoolID,
				lstSelected: this.lstPerson,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response.lstSelected != undefined) {
				this.lstPerson = response.lstSelected;
			}
		});
	}

	onRemovePerson(val) {
		this.lstPerson = this.lstPerson.filter((p) => p.PersonID != val.PersonID);
	}

	onAdd() {
		this.errorMessage = "";

		var fsDate = "";
		var feDate = "";

		if (this.DateRangeID == 2 || this.DateRangeID == 3) {
			fsDate = moment(this.StartDate).format("MM/DD/YYYY");
		}
		if (this.DateRangeID == 2 || this.DateRangeID == 4) {
			feDate = moment(this.EndDate).format("MM/DD/YYYY");
		}

		if (String(fsDate).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "Invalid Start Date";
			return;
		}
		if (String(feDate).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "Invalid End Date";
			return;
		}

		var fsTime = "";
		var feTime = "";

		if (this.TimeRangeID == 2 || this.TimeRangeID == 3) {
			fsTime = moment(this.StartTime).format("HH:mm:00");
		}
		if (this.TimeRangeID == 2 || this.TimeRangeID == 4) {
			feTime = moment(this.EndTime).format("HH:mm:00");
		}

		if (String(fsTime).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "Invalid Start Time";
			return;
		}
		if (String(feTime).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "Invalid End Time";
			return;
		}

		// Block After
		if (this.TimeRangeID == 3) {
			feTime = "23:59:59";
		}
		// Block Before
		else if (this.TimeRangeID == 4) {
			fsTime = "00:00:00";
		}

		if (this.TimeRangeID > 1 && String(fsTime) == String(feTime)) {
			this.errorMessage = "Invalid Time Range. Start Time = End Time (Blocks students for 0 minutes)";
			return;
		}

		this.Processing = true;

		var lstPID = this.lstPerson.map((item: any) => item.PersonID);
		var lstGID = this.lstGroup.map((item: any) => item.GroupID);
		var lstHID = this.lstHomeroom.map((item: any) => item.HomeroomID);

		var parms: StationBlockAlertInsertRequest = {
			SchoolID: this.SelectedSchool.SchoolID,
			Message: this.Message,
			StartDate: fsDate,
			EndDate: feDate,
			StartTime: fsTime,
			EndTime: feTime,
			Priority: this.PriorityID,
			lstPersonID: lstPID,
			lstGroupID: lstGID,
			lstHomeroomID: lstHID,
		};

		var result = this.dataService.StationBlockAlertInsert(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Status == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "stationblockalertadd",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Block List was added successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "stationblockalertadd",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add the Block List: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	//////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////////////////////
	IsLoading() {
		return this.Processing == true;
	}
	//////////////////////////////////////////////////////////
}
